<template>
    <v-container>
        <div>
          <v-row justify="space-between">
              <v-col cols="12" sm="6" justify="center">
                  <p class="header-title"> {{$t('block_management.title')}} </p>
              </v-col>

              <v-col cols="12" sm="6" justify="center" class="pr-5">
                <v-row class="d-flex justify-end">
                    <v-dialog v-model="dialog" persistent max-width="600px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t('common.add')}}</v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col>
                                            <v-text-field v-model="editedItem.name" :rules="stringRules" v-bind:label="$t('block_management.name')"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col>
                                        <v-combobox v-model="selectType" :items="types" item-text="name" v-bind:label="$t('block_management.view_group')"></v-combobox>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field v-model="editedItem.description" v-bind:label="$t('block_management.description')"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" dark @click="close">{{ $t('common.cancel')}}</v-btn>
                                <v-btn color="primary" dark @click="save">{{ $t('common.save')}}</v-btn>
                            </v-card-actions>
                        </v-card>
                  </v-dialog>
                </v-row>
                  
              </v-col>
          </v-row>
        </div>
        <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
            <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined dense></v-text-field>
                </v-toolbar>
            </template>

            <template v-slot:[`item.action`]="{ item }">
                <v-icon  small class="mr-2"  @click="editItem(item)">
                    edit
                </v-icon>
                <v-icon  small @click="deleteItem(item)">
                    delete
                </v-icon>

            </template>

            <template v-slot:[`item.type`]="{ item }">
                {{ getViewName(item) }}

            </template>

            <template v-slot:no-data>
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
        </v-data-table>

        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
    </v-container>
</template>

<script>
  import i18n from '@/plugins/i18n';

  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      selectType: {},
      loading: true,

      search: '',
      dialog: false,
      headers: [
        { text: '#', align: 'left', sortable: false, value: 'index', },
        { text: i18n.t('block_management.identify'), sortable: false, value: '_id' },
        { text: i18n.t('block_management.name'), value: 'name' },
        { text: i18n.t('block_management.description'), sortable: false, value: 'description' },
        { text: i18n.t('block_management.view_group'), sortable: false, value: 'type' },
        { text: '', value: 'action', sortable: false }
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
      stringRules: [
          v => !!v || i18n.t('validate.not_empty'),
          // v => (v && v.length > 5) || i18n.t('validate.string_invalid')
      ],
      types: [
        {name: 'Khối kinh doanh', value: 1}, //Khối Kinh doanh
        {name: 'Khối thiết kế', value: 2}, //Khối Design
        {name: 'Khối TCKT', value: 3}, //Khối TCKT
        {name: 'Khối Logistic', value: 4},
      ]
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('block_management.add_block') : i18n.t('block_management.edit_block')
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    async mounted() {
      await this.getData()
    },

    methods: {
      initialize () {
        this.selectType = this.types[1];
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const agree = confirm(i18n.t('common.confirm_delete'))
        if (agree) {
          const response =  await this.$http.delete("/context/" + item._id);
          if(response.data && response.data.success) {
              this.desserts.splice(item.index - 1, 1);
              this.desserts.forEach((item, index) =>item.index = index + 1);
          } else if(response.data && !response.data.success) {
              alert(i18n.t(response.data.message));
          } else {
              alert(i18n.t('validate.request_error'));
          }
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save () {
        if (!this.editedItem.name || this.editedItem.name.length == 0) {
          alert(i18n.t('validate.infor_empty'))
          return;
        }

        if (this.editedIndex > -1) {
          const self = this;
          const requestBody = self.editedItem;
          requestBody.type = this.selectType.value;

          try {
              const response = await this.$http.put(process.env.VUE_APP_CONTEXT_URL + self.editedItem._id, requestBody);
              if (response.data && response.data.success) {
                  Object.assign(this.desserts[this.editedIndex], this.editedItem);
                  self.editedItem = {};
              } else if(response.data && !response.data.success) {
                  alert(i18n.t(response.data.message));
              } else {
                  alert(i18n.t('validate.request_error'));
              } 
            } catch (e) {
                console.log(e.stack);
                alert(i18n.t('validate.request_error'));
            }
        } else {
            const self = this;
            const requestBody = self.editedItem;
            requestBody.type = this.selectType.value;
            try {
                const response =  await this.$http.post(process.env.VUE_APP_CONTEXT_URL, requestBody);
                if(response.data && response.data.success) {
                    self.editedItem._id = response.data.data.id;
                    
                    this.desserts.push(self.editedItem);
                    self.editedItem.index = this.desserts.length;
                    self.editedItem = {};

                    this.$fire({
                        title: i18n.t('common.success'),
                        text: "",
                        type: "success"
                        }).then(() => {
                            
                    });

                } else if(response.data && !response.data.success) {
                    alert(i18n.t(response.data.message));
                } else {
                    alert(i18n.t('validate.request_error'));
                } 
            } catch(e) {
                console.log(e.stack);
                alert(i18n.t('validate.request_error'));
            }
        }
        this.close()
      },

      getViewName(item) {
        if (item.type) {
          return this.types[item.type - 1].name;
        }
        
        return '';
      },

      async getData() {
        try {
            const response =  await this.$http.get(process.env.VUE_APP_GET_BLOCK_URL);
            if(response.data && response.data.success) {
                const contextArr = response.data.data;
                contextArr.forEach((item, index) =>item.index = index + 1);

                this.desserts = contextArr;

                this.loading = false;
            } else if(response.data && !response.data.success) {
                alert(i18n.t(response.data.message));
            } else {
                alert(i18n.t('validate.request_error'));
            } 
        } catch(e) {
            alert(i18n.t('validate.request_error'));
        }
      }
    },
  }
</script>

<style scoped>

  .v-text-field .v-input__control .v-input__slot {
    min-height: 45px !important;
    /* display: flex !important; */
    align-items: center !important;
  }
</style>